import { connect } from 'react-redux';
import TopicsView from '../../components/Topics/TopicsView';
import {
    fetchThematicPlanningTree,
    clearThematicPlanningTree,
    fetchThematicPlanningLesson,
    clearThematicPlanningLesson,
    openThematicPlanningLessonFile,
} from '../../actions/thematicPlanning';

const mapStateToProps = ({ thematicPlanning }, ownProps) => ({
    id: ownProps.match.params.id,
    tree: thematicPlanning.tree,
    isLoadingTree: thematicPlanning.isLoadingTree,
    treeError: thematicPlanning.treeError,
    lesson: thematicPlanning.lesson,
    isLoadingLesson: thematicPlanning.isLoadingLesson,
    lessonError: thematicPlanning.lessonError,
});

const mapDispatchToProps = (dispatch) => ({
    fetchThematicPlanningTree: (id) => dispatch(fetchThematicPlanningTree(id)),
    clearThematicPlanningTree: () => dispatch(clearThematicPlanningTree()),
    fetchThematicPlanningLesson: (lessonId) => dispatch(fetchThematicPlanningLesson(lessonId)),
    clearThematicPlanningLesson: () => dispatch(clearThematicPlanningLesson()),
    openLessonFile: (lessonId, fileId, opts) =>
        dispatch(openThematicPlanningLessonFile(lessonId, fileId, opts)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TopicsView);
